import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getRubbers({ commit }, {
        paginate = '',
        query = '',
    } = {}) {

        commit('GET_RUBBERS_REQUEST')

        return axios
            .get(`/rubbers/rubbers${paginate}${query}`)
            .then(response => {
                commit('GET_RUBBERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_RUBBERS_FAILURE')
                handleApiError(error, 'Pobranie gum nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDeletedRubbers() {
        return axios
            .get('/rubbers/rubbers?limit=3&deleted=true')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie dostępnych numerów gum nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRubberStatuses({ commit }) {
        return axios
            .get('rubbers/rubbers/dicts/rubber-statuses')
            .then(response => {
                commit('GET_RUBBER_STATUSES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_RUBBER_STATUSES_FAILURE')
                handleApiError(error, 'Pobranie statusów gum nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setRubberStatus(_, { rubberId, statusId }) {
        return axios
            .put(`/rubbers/rubbers/${rubberId}`, { statusId })
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zmiana statusu gumy nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteRubber({ commit }, id) {
        commit('DELETE_RUBBER_REQUEST')

        return axios
            .delete(`/rubbers/rubbers/${id}`)
            .then(response => {
                commit('DELETE_RUBBER_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('DELETE_RUBBER_FAILURE')
                handleApiError(error, 'Usunięcie gumy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateRubbersReport({ commit }, {
        userEmail,
        paginate = '',
        query = '',
    } = {}) {
        commit('GENERATE_RUBBERS_REPORT')

        return axios
            .get(`/rubbers/rubbers${paginate}${query}&report=true`)
            .then(response => {
                commit('GENERATE_RUBBERS_REPORT_SUCCESS')
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport zostanie wygenerowany i przesłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GENERATE_RUBBERS_REPORT_FAILURE')
                handleApiError(error, 'Generowanie raportu rejestru gum nie powiodło się')

                return Promise.reject(error)
            })
    },
    createRubber(_, rubber) {
        return axios
            .post('/rubbers/rubbers', rubber)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie gumy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRubbersRaw({ commit }) {
        return axios
            .get('/rubbers/rubbers-raw')
            .then(response => {
                commit('GET_RUBBERS_RAW_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy gum nie powiodło się.')

                return Promise.reject(error)
            })
    },
    searchAdditionalJobNumbers({ commit }, { search, limit = 20 } = {}) {
        const trimmedSearch = (search || '').trim()

        if (trimmedSearch.length < 3) {
            commit('CLEAR_ADDITIONAL_JOB_NUMBERS')

            return Promise.resolve()
        }

        commit('SEARCH_ADDITIONAL_JOB_NUMBERS_REQUEST')

        return axios
            .get(`/reports/report-items/rubbers-additional-objects?limit=${limit}&search=${encodeURIComponent(trimmedSearch)}`)
            .then(response => {
                commit('SEARCH_ADDITIONAL_JOB_NUMBERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('SEARCH_ADDITIONAL_JOB_NUMBERS_FAILURE')
                handleApiError(error, 'Wyszukiwanie zleceń nie powiodło się.')

                return Promise.reject(error)
            })
    },
    saveAdditionalJobNumbers({ commit }, payload) {
        commit('SAVE_ADDITIONAL_JOB_NUMBERS_REQUEST')

        return axios
            .post('/rubbers/rubbers/additional-job-numbers', payload)
            .then(response => {
                commit('SAVE_ADDITIONAL_JOB_NUMBERS_SUCCESS')
                commit('CLEAR_ADDITIONAL_JOB_NUMBERS')
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Pozostałe numery zleceń zostały zapisane.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('SAVE_ADDITIONAL_JOB_NUMBERS_FAILURE')
                handleApiError(error, 'Zapis pozostałych numerów zleceń nie powiódł się.')

                return Promise.reject(error)
            })
    },
    clearAdditionalJobNumbers({ commit }) {
        commit('CLEAR_ADDITIONAL_JOB_NUMBERS')
    },
    getRubberComments({ commit }, rubberId) {
        commit('GET_RUBBER_COMMENTS_REQUEST')

        return axios
            .get(`/rubbers/rubbers/comments?rubber_id=${rubberId}`)
            .then(response => {
                commit('GET_RUBBER_COMMENTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_RUBBER_COMMENTS_FAILURE')
                handleApiError(error, 'Pobranie komentarzy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createRubberComment({ commit }, { rubberId, text }) {
        commit('CREATE_RUBBER_COMMENT_REQUEST')

        return axios
            .post('/rubbers/rubbers/comments', { rubberId, text })
            .then(response => {
                commit('CREATE_RUBBER_COMMENT_SUCCESS')
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Komentarz został dodany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('CREATE_RUBBER_COMMENT_FAILURE')
                handleApiError(error, 'Dodanie komentarza nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteRubberComment({ commit }, commentId) {
        commit('DELETE_RUBBER_COMMENT_REQUEST')

        return axios
            .delete(`/rubbers/rubbers/comments/${commentId}`)
            .then(response => {
                commit('DELETE_RUBBER_COMMENT_SUCCESS')
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Komentarz został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('DELETE_RUBBER_COMMENT_FAILURE')
                handleApiError(error, 'Usunięcie komentarza nie powiodło się.')

                return Promise.reject(error)
            })
    },
    clearRubberComments({ commit }) {
        commit('CLEAR_RUBBER_COMMENTS')
    }
}
